import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import LoginElement from "../auth/left-panel";
import { ImEye } from "react-icons/im";
import { ImEyeBlocked } from "react-icons/im";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleLogin = (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Password validation
    if (!password) {
      validationErrors.password = "Password is required.";
    }

    // Confirm Password validation
    if (!confirmPassword) {
      validationErrors.confirmPassword = "Confirm Password is required.";
    } else if (confirmPassword !== password) {
      validationErrors.confirmPassword = "Passwords do not match.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // ✅ Proceed with reset if no errors
    setErrors({});
  };

  return (
    <div className="login">
      <div className="content-section">
        <LoginElement />
      </div>
      <div className="form-section">
        <div className='l-form-element l-forgot'>
          <h1>Reset Your Password</h1>
          <p>Enter your new password and confirm, then sign in.</p>
          <Form onSubmit={handleLogin}>
            {/* Password Input Group with Validation */}
            <div className="mb-3 position-relative">
              <Form.Floating>
                <Form.Control
                  id="floatingPasswordCustom"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={errors.password ? "is-invalid" : ""}
                />
                <label htmlFor="floatingPasswordCustom">New Password</label>
              </Form.Floating>
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                className="position-absolute top-50 translate-middle-y password-view-btn"
                style={{ border: "none" }}
              >
                {showPassword ? <ImEyeBlocked /> : <ImEye />}
              </Button>
              {errors.password && <div className="text-danger mt-1">{errors.password}</div>} {/* ✅ Password error message */}
            </div>

            {/* Confirm Password Input Group with Validation */}
            <div className="mb-3 position-relative">
              <Form.Floating>
                <Form.Control
                  id="floatingConfirmPasswordCustom"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={errors.confirmPassword ? "is-invalid" : ""}
                />
                <label htmlFor="floatingConfirmPasswordCustom">Confirm Password</label>
              </Form.Floating>
              <Button
                variant="outline-secondary"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="position-absolute top-50 translate-middle-y password-view-btn"
                style={{ border: "none" }}
              >
                {showConfirmPassword ? <ImEyeBlocked /> : <ImEye />}
              </Button>
              {errors.confirmPassword && <div className="text-danger mt-1">{errors.confirmPassword}</div>} {/* ✅ Confirm Password error message */}
            </div>

            {/* Submit button */}
            <Button type="submit" className="btn btn-primary w-100 login-btn">
              Send Reset Link
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
